var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"ui-sliding-indicator",style:(_vm.indicatorStyle),attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }